module.exports = __webpack_public_path__ + "d5c3621a6ce10335353c2c3b89459cdd.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/tourWorks/room1/audio1/01_MCA Meditation for Suburb Brain.mp3
// module id = 764
// module chunks = 0